const DEFAULT_LANGUAGE = "en";

const getLanguage = (): string => {
  const storedLanguage = window.localStorage.getItem("lng");
  if (storedLanguage) return storedLanguage;
  return DEFAULT_LANGUAGE;
};

export default getLanguage;
